<p-toast></p-toast>
<p-dialog
	[(visible)]="showModal"
	[header]="mode === 'update' ? ('modals.updateCustomer.title' | translate) : ('modals.addCustomer.title' | translate)"
	[modal]="true"
	[style]="{ width: 'min(92vw, 920px)', maxWidth: '100%' }"
	[contentStyle]="{ maxHeight: 'min(88vh, 800px)', overflowY: 'auto', overflowX: 'hidden', padding: '0' }"
	[draggable]="false"
	[resizable]="false"
	[maximizable]="true"
	[breakpoints]="{ '960px': '96vw', '576px': '100vw' }"
	(onHide)="dismissModal()"
	(focusout)="onModalFocusOut($event)"
	styleClass="add-customer-dialog customer-form-dialog">

	<div class="edit-profile customer-form-shell">
		<p class="customer-form-lead">
			{{ (mode === 'update' ? 'shared.addCustomerModal.updateLead' : 'shared.addCustomerModal.addLead') | translate }}
		</p>

		<form [formGroup]="addCustomer" novalidate>
			<!-- Identity -->
			<section class="customer-form-section">
				<header class="customer-form-section__head">
					<span class="customer-form-section__icon" aria-hidden="true"><i class="fa fa-user"></i></span>
					<h3 class="customer-form-section__title">{{ 'shared.addCustomerModal.sections.identity' | translate }}</h3>
				</header>
				<div class="customer-form-section__body row g-3 p-fluid">
					<div class="col-12 col-md-6 col-xl-4">
						<label class="customer-form-label">
							{{ 'shared.addCustomerModal.labels.customerNameHe' | translate }}
							<span class="text-danger">*</span>
						</label>
						<input
							pInputText
							type="text"
							formControlName="customer_name_he"
							maxlength="80"
							required
							class="w-100"
							(input)="addCustomer.patchValue({ customer_name_ar: $event.target.value, customer_name_en: $event.target.value })"
							[ngClass]="{ 'ng-invalid ng-dirty': addCustomer.controls['customer_name_he'].invalid && (addCustomer.controls['customer_name_he'].dirty || addCustomer.controls['customer_name_he'].touched) }" />
						<div
							*ngIf="addCustomer.controls['customer_name_he'].invalid && (addCustomer.controls['customer_name_he'].dirty || addCustomer.controls['customer_name_he'].touched)"
							class="invalid-feedback text-danger d-block">
							<div *ngIf="addCustomer.controls['customer_name_he'].errors?.['required']">
								{{ 'shared.addCustomerModal.validation.customerNameRequired' | translate }}
							</div>
						</div>
					</div>

					<div class="col-12 col-md-6 col-xl-4">
						<label class="customer-form-label">
							{{ 'shared.addCustomerModal.labels.customerType' | translate }}
							<span class="text-danger">*</span>
						</label>
						<p-selectButton
							formControlName="customer_type"
							[options]="customerTypeData"
							[optionLabel]="curentLang === 'en' ? 'lookupDetailEnName' : curentLang === 'ar' ? 'lookupDetailArName' : 'lookupDetailHeName'"
							optionValue="lookup_detail_id"
							[multiple]="false"
							required
							[styleClass]="
								'customer-type-select w-100' +
								(addCustomer.controls['customer_type'].invalid &&
								(addCustomer.controls['customer_type'].dirty || addCustomer.controls['customer_type'].touched)
									? ' ng-invalid ng-dirty'
									: '')
							">
						</p-selectButton>
						<div
							*ngIf="addCustomer.controls['customer_type'].invalid && (addCustomer.controls['customer_type'].dirty || addCustomer.controls['customer_type'].touched)"
							class="invalid-feedback text-danger d-block">
							<div *ngIf="addCustomer.controls['customer_type'].errors?.['required']">
								{{ 'shared.addCustomerModal.validation.customerTypeRequired' | translate }}
							</div>
						</div>
					</div>

					<div class="col-12 col-md-6 col-xl-4" *ngIf="showCompanySelect">
						<label class="customer-form-label">
							{{ 'shared.addCustomerModal.labels.company' | translate }}
							<span class="text-danger">*</span>
						</label>
						<p-dropdown
							formControlName="company_id"
							[options]="companiesList"
							optionLabel="companyDisplayLabel"
							optionValue="company_id"
							[placeholder]="'shared.addCustomerModal.placeholders.selectCompany' | translate"
							[filter]="true"
							filterBy="companyDisplayLabel,company_name_en,company_name_ar,company_name_he"
							[showClear]="false"
							appendTo="body"
							styleClass="company-select-dropdown w-100"
							[ngClass]="
								addCustomer.controls['company_id'].invalid &&
								(addCustomer.controls['company_id'].dirty || addCustomer.controls['company_id'].touched)
									? 'ng-invalid ng-dirty'
									: ''
							">
							<ng-template let-company pTemplate="item">
								<div class="company-dropdown-item-label">{{ getCompanyName(company) }}</div>
							</ng-template>
							<ng-template let-company pTemplate="selectedItem">
								<span class="company-selected-item">{{ getCompanyName(company) }}</span>
							</ng-template>
						</p-dropdown>
						<div
							*ngIf="addCustomer.controls['company_id'].invalid && (addCustomer.controls['company_id'].dirty || addCustomer.controls['company_id'].touched)"
							class="invalid-feedback text-danger d-block">
							<div *ngIf="addCustomer.controls['company_id'].errors?.['required']">
								{{ 'shared.addCustomerModal.validation.companyRequired' | translate }}
							</div>
						</div>
					</div>
				</div>
			</section>

			<!-- Contact -->
			<section class="customer-form-section">
				<header class="customer-form-section__head">
					<span class="customer-form-section__icon" aria-hidden="true"><i class="fa fa-phone"></i></span>
					<h3 class="customer-form-section__title">{{ 'shared.addCustomerModal.sections.contact' | translate }}</h3>
				</header>
				<div class="customer-form-section__body row g-3 p-fluid">
					<div class="col-12 col-md-6">
						<label class="customer-form-label">{{ 'shared.addCustomerModal.labels.phoneNumber' | translate }}</label>
						<div class="p-inputgroup">
							<span class="p-inputgroup-addon phone-prefix">+972</span>
							<input
								pInputText
								type="text"
								formControlName="customer_phone"
								pKeyFilter="pint"
								maxlength="9"
								class="w-100"
								[ngClass]="{ 'ng-invalid ng-dirty': addCustomer.controls['customer_phone'].invalid && (addCustomer.controls['customer_phone'].dirty || addCustomer.controls['customer_phone'].touched) }" />
						</div>
						<div
							*ngIf="addCustomer.controls['customer_phone'].invalid && (addCustomer.controls['customer_phone'].dirty || addCustomer.controls['customer_phone'].touched)"
							class="invalid-feedback text-danger d-block">
							{{ 'shared.addCustomerModal.validation.phoneInvalid' | translate }}
						</div>
					</div>

					<div class="col-12 col-md-6">
						<label class="customer-form-label">{{ 'shared.addCustomerModal.labels.email' | translate }}</label>
						<input
							pInputText
							type="email"
							formControlName="customer_email"
							class="w-100"
							[ngClass]="{ 'ng-invalid ng-dirty': addCustomer.controls['customer_email'].invalid && (addCustomer.controls['customer_email'].dirty || addCustomer.controls['customer_email'].touched) }" />
						<div
							*ngIf="addCustomer.controls['customer_email'].invalid && (addCustomer.controls['customer_email'].dirty || addCustomer.controls['customer_email'].touched)"
							class="invalid-feedback text-danger d-block">
							{{ 'shared.addCustomerModal.validation.emailInvalid' | translate }}
						</div>
					</div>

					<div class="col-12">
						<div class="customer-contact-checkbox">
							<p-checkbox
								formControlName="show_contact_on_documents"
								inputId="showContactOnDocuments"
								[binary]="true">
							</p-checkbox>
							<label
								for="showContactOnDocuments"
								class="customer-contact-checkbox__label"
								[pTooltip]="'shared.addCustomerModal.tooltips.showContactOnDocuments' | translate"
								tooltipPosition="top">
								{{ 'shared.addCustomerModal.labels.showContactOnDocuments' | translate }}
							</label>
						</div>
						<div *ngIf="showNoContactDetailsWarning" class="customer-contact-checkbox__warning">
							<i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
							<span>{{ 'shared.addCustomerModal.validation.noContactToShow' | translate }}</span>
						</div>
					</div>
				</div>
			</section>

			<!-- Address -->
			<section class="customer-form-section">
				<header class="customer-form-section__head">
					<span class="customer-form-section__icon" aria-hidden="true"><i class="fa fa-map-marker"></i></span>
					<h3 class="customer-form-section__title">{{ 'shared.addCustomerModal.sections.address' | translate }}</h3>
				</header>
				<div class="customer-form-section__body row g-3 p-fluid">
					<div class="col-12 col-md-6 col-xl-3">
						<label class="customer-form-label">{{ 'shared.addCustomerModal.labels.city' | translate }}</label>
						<input pInputText type="text" formControlName="customer_address_city" maxlength="100" class="w-100" />
					</div>
					<div class="col-12 col-md-6 col-xl-3">
						<label class="customer-form-label">{{ 'shared.addCustomerModal.labels.street' | translate }}</label>
						<input pInputText type="text" formControlName="customer_address_str" maxlength="100" class="w-100" />
					</div>
					<div class="col-12 col-md-6 col-xl-3">
						<label class="customer-form-label">{{ 'shared.addCustomerModal.labels.buildingNumber' | translate }}</label>
						<input pInputText type="text" formControlName="customer_Building_number" maxlength="100" class="w-100" />
					</div>
					<div class="col-12 col-md-6 col-xl-3">
						<label class="customer-form-label">{{ 'shared.addCustomerModal.labels.zipCode' | translate }}</label>
						<input pInputText type="text" formControlName="customer_address_zip_code" pKeyFilter="pint" maxlength="20" class="w-100" />
					</div>
				</div>
			</section>

			<!-- Tax & IDs -->
			<section class="customer-form-section">
				<header class="customer-form-section__head">
					<span class="customer-form-section__icon" aria-hidden="true"><i class="fa fa-briefcase"></i></span>
					<h3 class="customer-form-section__title">{{ 'shared.addCustomerModal.sections.tax' | translate }}</h3>
				</header>
				<div class="customer-form-section__body row g-3 p-fluid">
					<div class="col-12 col-md-6 col-xl-4" *ngIf="addCustomer.value.customer_type != 6">
						<label class="customer-form-label">{{ 'shared.addCustomerModal.labels.idNumber' | translate }}</label>
						<input
							pInputText
							type="text"
							formControlName="id_number"
							pKeyFilter="pint"
							maxlength="9"
							class="w-100"
							[ngClass]="{ 'ng-invalid ng-dirty': addCustomer.controls['id_number'].invalid && (addCustomer.controls['id_number'].dirty || addCustomer.controls['id_number'].touched) }" />
						<div
							*ngIf="addCustomer.controls['id_number'].invalid && (addCustomer.controls['id_number'].dirty || addCustomer.controls['id_number'].touched)"
							class="invalid-feedback text-danger d-block">
							<div *ngIf="addCustomer.controls['id_number'].errors?.['required']">
								{{ 'shared.addCustomerModal.validation.idRequired' | translate }}
							</div>
							<div *ngIf="addCustomer.controls['id_number'].errors?.['minlength'] || addCustomer.controls['id_number'].errors?.['maxlength']">
								{{ 'shared.addCustomerModal.validation.idLength' | translate }}
							</div>
							<div *ngIf="addCustomer.controls['id_number'].errors?.['pattern']">
								{{ 'shared.addCustomerModal.validation.idPattern' | translate }}
							</div>
						</div>
					</div>

					<div class="col-12 col-md-6 col-xl-4" *ngIf="addCustomer.value.customer_type == 6">
						<label class="customer-form-label">{{ 'shared.addCustomerModal.labels.vatNumber' | translate }}</label>
						<input
							pInputText
							type="text"
							formControlName="id_number"
							pKeyFilter="pint"
							maxlength="9"
							class="w-100"
							(blur)="onCompanyFieldBlur($event, 'id_number')"
							[ngClass]="{ 'ng-invalid ng-dirty': addCustomer.controls['id_number'].invalid && (addCustomer.controls['id_number'].dirty || addCustomer.controls['id_number'].touched) }" />
						<div
							*ngIf="addCustomer.controls['id_number'].invalid && (addCustomer.controls['id_number'].dirty || addCustomer.controls['id_number'].touched)"
							class="invalid-feedback text-danger d-block">
							<div *ngIf="addCustomer.controls['id_number'].errors?.['required']">
								{{ 'shared.addCustomerModal.validation.idRequired' | translate }}
							</div>
							<div *ngIf="addCustomer.controls['id_number'].errors?.['minlength'] || addCustomer.controls['id_number'].errors?.['maxlength']">
								{{ 'shared.addCustomerModal.validation.idLength' | translate }}
							</div>
							<div *ngIf="addCustomer.controls['id_number'].errors?.['pattern']">
								{{ 'shared.addCustomerModal.validation.idPattern' | translate }}
							</div>
						</div>
					</div>

					<div class="col-12 col-md-6 col-xl-4">
						<label class="customer-form-label">{{ 'shared.addCustomerModal.labels.vatTaxNumber' | translate }}</label>
						<input
							pInputText
							type="text"
							formControlName="customer_vat_number"
							pKeyFilter="pint"
							maxlength="9"
							class="w-100"
							(blur)="onCompanyFieldBlur($event, 'customer_vat_number')"
							[ngClass]="{ 'ng-invalid ng-dirty': addCustomer.controls['customer_vat_number'].invalid && (addCustomer.controls['customer_vat_number'].dirty || addCustomer.controls['customer_vat_number'].touched) }" />
						<div
							*ngIf="addCustomer.controls['customer_vat_number'].invalid && (addCustomer.controls['customer_vat_number'].dirty || addCustomer.controls['customer_vat_number'].touched)"
							class="invalid-feedback text-danger d-block">
							<div *ngIf="addCustomer.controls['customer_vat_number'].errors?.['minlength'] || addCustomer.controls['customer_vat_number'].errors?.['maxlength']">
								{{ 'shared.addCustomerModal.validation.vatLength' | translate }}
							</div>
							<div *ngIf="addCustomer.controls['customer_vat_number'].errors?.['pattern']">
								{{ 'shared.addCustomerModal.validation.vatPattern' | translate }}
							</div>
						</div>
					</div>

					<div class="col-12 col-md-6 col-xl-4">
						<label class="customer-form-label">{{ 'shared.addCustomerModal.labels.companyIdNumber' | translate }}</label>
						<input
							pInputText
							type="text"
							formControlName="customer_vat_tax"
							pKeyFilter="pint"
							maxlength="9"
							class="w-100"
							(blur)="onCompanyFieldBlur($event, 'customer_vat_tax')"
							[ngClass]="{ 'ng-invalid ng-dirty': addCustomer.controls['customer_vat_tax'].invalid && (addCustomer.controls['customer_vat_tax'].dirty || addCustomer.controls['customer_vat_tax'].touched) }" />
						<div
							*ngIf="addCustomer.controls['customer_vat_tax'].invalid && (addCustomer.controls['customer_vat_tax'].dirty || addCustomer.controls['customer_vat_tax'].touched)"
							class="invalid-feedback text-danger d-block">
							<div *ngIf="addCustomer.controls['customer_vat_tax'].errors?.['minlength'] || addCustomer.controls['customer_vat_tax'].errors?.['maxlength']">
								{{ 'shared.addCustomerModal.validation.vatTaxLength' | translate }}
							</div>
							<div *ngIf="addCustomer.controls['customer_vat_tax'].errors?.['pattern']">
								{{ 'shared.addCustomerModal.validation.vatTaxPattern' | translate }}
							</div>
						</div>
					</div>
				</div>
			</section>
		</form>
	</div>

	<ng-template pTemplate="footer">
		<div class="customer-form-footer">
			<p-button
				icon="pi pi-times"
				styleClass="p-button-outlined p-button-secondary customer-form-footer__cancel"
				(click)="dismissModal()"
				[label]="'modals.common.back' | translate">
			</p-button>
			<p-button
				icon="pi pi-check"
				styleClass="p-button-success customer-form-footer__save"
				(click)="addedData()"
				[label]="mode === 'update' ? ('modals.common.update' | translate) : ('modals.common.confirm' | translate)">
			</p-button>
		</div>
	</ng-template>
</p-dialog>
